import { render } from "./QuizCompleted.vue?vue&type=template&id=34e745fc&scoped=true"
import script from "./QuizCompleted.vue?vue&type=script&lang=js"
export * from "./QuizCompleted.vue?vue&type=script&lang=js"

import "./QuizCompleted.vue?vue&type=style&index=0&id=34e745fc&scoped=true&lang=css"

import exportComponent from "/home/marco/keyos-projects/esamiFinanza/webapp-esamifinanza/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34e745fc"]])

export default __exports__